import { render } from "./TradePage.vue?vue&type=template&id=3ba1deb8"
import script from "./TradePage.vue?vue&type=script&lang=js"
export * from "./TradePage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TradePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ba1deb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ba1deb8', __exports__)) {
    api.reload('3ba1deb8', __exports__)
  }
  
  module.hot.accept("./TradePage.vue?vue&type=template&id=3ba1deb8", () => {
    api.rerender('3ba1deb8', render)
  })

}


export default __exports__